module.exports = __webpack_public_path__ + "img/printTop.0a974013.png";